// LoanPipelineSecurityGroupSource (Skynet.Loans) provenance byte. The broker Pipeline Access tab
// only ever reads/writes the last two: Lender rows are pipeline-editor–owned and rejected by these
// endpoints. Wire value is the numeric enum byte; the compose layer also tolerates the string name
// in case the service serializes the enum by name.
export const LoanPipelineSecurityGroupSource = {
  LENDER: 0,
  TPO_SEEDED: 1,
  SUB_COMPANY_MANAGED: 2,
};

const LoanPipelineSecurityGroupSourceName = {
  TPO_SEEDED: 'TpoSeeded',
  SUB_COMPANY_MANAGED: 'SubCompanyManaged',
};

export const checkIsTpoSeededSource = source =>
  source === LoanPipelineSecurityGroupSource.TPO_SEEDED ||
  source === LoanPipelineSecurityGroupSourceName.TPO_SEEDED;

export const checkIsSubCompanyManagedSource = source =>
  source === LoanPipelineSecurityGroupSource.SUB_COMPANY_MANAGED ||
  source === LoanPipelineSecurityGroupSourceName.SUB_COMPANY_MANAGED;

// Exposure scope echoed by the SkynetAPI exposed-pipelines BFF (verbatim string constants, not an
// enum). "All" reaches every active channel; "SpecificChannels" reaches only the intersection.
export const PipelineExposureScopeType = {
  ALL: 'All',
  SPECIFIC_CHANNELS: 'SpecificChannels',
};
